// extracted by mini-css-extract-plugin
export var filterIncDec = "_b8-0";
export var leftBorder = "_b8-1";
export var rightBorder = "_b8-2";
export var stringInput = "_b8-3";